import { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Line,
  Legend,
} from "recharts";
import formatMoney from "../../../utils/formatMoney";
import AssetsPanel from "./AssetsPanel";

const monthTickFormatter: any = (tick: any) => {
  const date = new Date(tick);

  return date.getMonth() + 1;
};

const DataFormater = (number: any) => {
  if (number > 1000000000) {
    return (number / 1000000000).toString() + "B";
  } else if (number > 1000000) {
    return (number / 1000000).toString() + "M";
  } else if (number > 1000) {
    return (number / 1000).toString() + "K";
  } else {
    return number.toString();
  }
};

const renderQuarterTick = (tickProps: any) => {
  const { x, y, payload } = tickProps;
  const { value, offset } = payload;
  const date = new Date(value);
  const month = date.getMonth();
  const quarterNo = Math.floor(month / 3) + 1;

  if (month % 3 === 1) {
    return (
      <text
        x={x + offset}
        y={y - 4}
        textAnchor="middle"
      >{`Q${quarterNo}`}</text>
    );
  }

  const isLast = month === 11;

  if (month % 3 === 0 || isLast) {
    const pathX = Math.floor(isLast ? x + offset * 2 : x) + 0.5;

    return <path d={`M${pathX},${y - 4}v${-35}`} stroke="red" />;
  }
  return null;
};

export default function MainChart({ data, year, center }: any) {
  const [isVisible, setVisible] = useState(false);
  const [expenses, setExpenses] = useState<any>([]);

  function expenseOnClick(e: any) {
    setVisible(true);
    setExpenses(e.payload);
  }

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const opex = payload?.price ? payload?.price : 0;
      // const capex = payload[0]?.payload?.expenses
      //   ? payload[0]?.payload?.capex_budget
      //   : 0;
      // const expenses = payload[0]?.payload?.expenses
      //   ? payload[0]?.payload?.expenses
      //   : 0;

      return (
        <div className="bg-white p-4 border border-gray-400">
          <div className="border-b font-bold pb-4">{`${payload[0].payload.name}`}</div>
          <div style={{ color: `#1E6431`, marginBottom: 5 }}>
            <div className="font-bold">Capital Budget</div>
            {/* <div className="">{`${formatMoney(capex)}`}</div> */}
          </div>
          <div style={{ color: `#14488B`, marginBottom: 5 }}>
            <div className="font-bold">Operational Budget</div>
            <div className="">{`${formatMoney(opex)}`}</div>
          </div>
          <div style={{ color: `#A4056B`, marginBottom: 5 }}>
            <div className="font-bold">Expenses</div>
            <div className="">{`${formatMoney(expenses)}`}</div>
          </div>
        </div>
      );
    }

    return null;
  };

  useEffect(() => {}, [year]);
  return (
    <>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={450}
          data={data}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 0,
          }}
          barCategoryGap={5}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="_id" />
          <XAxis
            dataKey="_id"
            axisLine={false}
            tickLine={false}
            interval={0}
            height={1}
            scale="band"
            xAxisId="quarter"
          />
          <YAxis tickFormatter={DataFormater} />
          <Tooltip
            // content={<CustomTooltip />}
            cursor={false}
          />

          <Bar
            dataKey="price"
            fill="#1E6431"
            name="Asset Amount"
            width={2}
            // onClick={expenseOnClick}
          />
          {/* <Bar
            dataKey="opex_budget"
            fill="#14488B"
            width={2}
            name="Operational Budget"
            onClick={expenseOnClick}
          />
          <Bar
            dataKey="expenses"
            fill="#A4056B"
            name="Expenses"
            width={2}
            onClick={expenseOnClick}
          /> */}
          <Legend verticalAlign="top" wrapperStyle={{ bottom: -20 }} />
        </BarChart>
      </ResponsiveContainer>
      {/* <AssetsPanel
        isVisible={isVisible}
        setVisible={setVisible}
        expenses={expenses}
        title={"name"}
        total={2300}
        year={year}
        center={center}
      /> */}
    </>
  );
}
